import fetch from "../auth/FetchInterceptor";
import { PIOTR_CSM_FALLBACK } from "../constants/CsmFallback";

export const getBrandDetails = async (companyId) => {
  return fetch({
    url: `/brand-store/companies/${companyId}/brand-details`,
    method: "get",
  });
};

export const updateBrandDetails = async (companyId, data) => {
  return fetch({
    url: `/brand-store/companies/${companyId}/brand-details`,
    method: "patch",
    data,
  });
};

export const uploadBrandLogos = async (companyId, formData) => {
  return fetch({
    url: `/brand-store/companies/${companyId}/brand-details-logo`,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getBrandDashboard = async () => {
  return fetch({
    url: `/brand-store/dashboard`,
    method: "get"
  });
};

export const getBrandStoreCategories = async () => {
  return fetch({
    url: `/brand-store/categories`,
    method: "get"
  });
};

export const getBrandStoreProductFilters = async ({ params } = {}) => {
  return fetch({
    url: `/brand-store/products-filters`,
    method: "get",
    params,
  });
};

//Products
export const getProducts = async ({ params }) => {
  return fetch({
    url: `/brand-store/products`,
    method: "get",
    params
  });
};

export const deleteProducts = async (data) => {
  return fetch({
    url: `/brand-store/products`,
    method: "delete",
    data
  });
};

export const getProductData = async ({ id }) => {
  return fetch({
    url: `/brand-store/products/${id}`,
    method: "get"
  });
};

export const deleteProductData = async ({ id }) => {
  return deleteProducts({ product_ids: [id] });
};

//Collections
export const getCollections = async ({ params }) => {
  return fetch({
    url: `/brand-store/collections`,
    method: "get",
    params
  });
};

export const createCollection = async (data) => {
  return fetch({ url: "/brand-store/collections", method: "post", data });
};

export const deleteCollections = async (data) => {
  return fetch({ url: "/brand-store/collections", method: "delete", data });
};

export const getCollectionData = async ({ id }) => {
  return fetch({
    url: `/brand-store/collections/${id}`,
    method: "get"
  });
};

export const updateCollectionData = async ({ id, ...data }) => {
  return fetch({
    url: `/brand-store/collections/${id}`,
    method: "put",
    data
  });
};

export const deleteCollectionData = async ({ id }) => {
  return fetch({
    url: `/brand-store/collections/${id}`,
    method: "delete"
  });
};

export const removeProductsFromCollection = async ({ collectionId, productIds }) => {
  return fetch({
    url: `/brand-store/collections/${collectionId}/products`,
    method: "delete",
    data: { product_ids: productIds }
  });
};

export const getStoresCreatedToday = async () => {
  return fetch({
    url: `/brand-store/stores-created-today`,
    method: "get"
  });
};

export const addProdToCollections = async ({ id, collection_ids }) => {
  return fetch({
    url: `/brand-store/products/${id}/collections`,
    method: "post",
    data: { collection_ids },
  });
};

export const deleteCollectionsFromProduct = async ({ id, collection_ids }) => {
  return fetch({
    url: `/brand-store/products/${id}/collections`,
    method: "delete",
    data: { collection_ids },
  });
};

export const getBrandStoreUsers = async () => {
  return fetch({
    url: `/brand-store/users`,
    method: "get"
  });
};

export const getBrandStoreInvitations = async () => {
  return fetch({
    url: `/brand-store/invitations`,
    method: "get"
  });
};

export const inviteBrandStoreUsers = async (emails) => {
  return fetch({
    url: `/brand-store/invite-users`,
    method: "post",
    data: { emails }
  });
};

export const resendBrandStoreInvitations = async (emails) => {
  return fetch({
    url: `/brand-store/resend-invitations`,
    method: "post",
    data: { emails }
  });
};

// Bulk invite — Step 1: upload a CSV (email column) so the BE parses + validates
// each row. Returns { data: [{email}], errors: [] }. On 422 the data array still
// holds all parsed rows so the FE can show errors and let the user correct them.
export const mapInvitationsTemplateFile = async (formData) => {
  return fetch({
    url: `/brand-store/map-invitations-template-file`,
    method: "post",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// Bulk invite — Step 2: send the validated invitation list.
export const sendMultipleInvitations = async (invitations) => {
  return fetch({
    url: `/brand-store/send-multiple-invitations`,
    method: "post",
    data: { invitations }
  });
};

export const getCSM = async () => {
  try {
    const res = await fetch({ url: `/csm`, method: "get" });
    const csm = res?.data ?? res;
    const hasCsm = csm && (csm.first_name || csm.email || csm.id);
    // No CSM assigned → fall back to Piotr so the UI always shows a CSM.
    return hasCsm ? res : { ...(res || {}), data: PIOTR_CSM_FALLBACK };
  } catch (e) {
    // API error / no CSM — still RESOLVE with the fallback (never reject:
    // some callers read res.data without a guard).
    return { data: PIOTR_CSM_FALLBACK };
  }
};